module["exports"] = [
  "SPA",
  "e figli",
  "Group",
  "s.r.l."
];
